import { render, staticRenderFns } from "./VisitsPopup.vue?vue&type=template&id=5e48584e&"
import script from "./VisitsPopup.vue?vue&type=script&lang=js&"
export * from "./VisitsPopup.vue?vue&type=script&lang=js&"
import style0 from "./VisitsPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports